import { PrintType, SharingDraftConfiguration } from '@/types';
import { isString } from '@/utils/isString';
import { getPrintColor, getPrintColorByFill } from '@/model/printType/getPrintColor';
import { isDigital } from '@/model/printType/isDigital';

export const getColorsFromPrintColorRGBs = (printColorRGBs: string) =>
  // the product representation of a sellable is missing the hash
  printColorRGBs.split(' ').map((color) => ({ fill: color.startsWith('#') ? color : `#${color}` }));

export const getPrintColors = (configuration: SharingDraftConfiguration, printType: PrintType) => {
  const printColorRGBs = 'printColorRGBs' in configuration && configuration.printColorRGBs;
  if (isString(printColorRGBs)) {
    return getColorsFromPrintColorRGBs(printColorRGBs);
  }

  const printColorId = 'printColorId' in configuration && configuration.printColorId;
  if (isString(printColorId)) {
    return printColorId.split(' ').map((colorId) => {
      const printColor = getPrintColor(printType, colorId);
      if (!printColor) {
        throw new Error(`Print Color ${colorId} not available on Print Type ${printType.id}`);
      }

      return printColor;
    });
  }

  // fallback for old text configurations (text, placeholderText, bendingText)
  //  after we replaced fill with printColorRGBs/printColorId properties
  let fill = 'fill' in configuration && configuration.fill;
  if (isString(fill)) {
    if (isDigital(printType)) {
      return [{ fill: fill }];
    }

    fill = fill.toUpperCase();
    const printColor = getPrintColorByFill(printType, fill);
    if (!printColor) {
      throw new Error(`Print Color ${fill} not available on Print Type ${printType.id}`);
    }

    return [printColor];
  }

  return [];
};
